'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendVisitorEmailAddressSucceeded = exports.sendVisitorEmailAddressFailed = exports.sendVisitorEmailAddressRequested = undefined;
exports.sendVisitorEmailAddress = sendVisitorEmailAddress;

var _reduxActions = require('redux-actions');

var _getSessionId = require('../../selectors/widgetDataSelectors/getSessionId');

var _VisitorActionTypes = require('../../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _publishEmailCaptureResponseMessage = require('./publishEmailCaptureResponseMessage');

var _publishEmailCaptureResponseMessage2 = _interopRequireDefault(_publishEmailCaptureResponseMessage);

var _EmailCaptureClient = require('../EmailCaptureClient');

var EmailCaptureClient = _interopRequireWildcard(_EmailCaptureClient);

var _visitorConsentsToCommunicate = require('../../gdpr/actions/visitorConsentsToCommunicate');

var _trackInteraction = require('../../usage-tracking/actions/trackInteraction');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var sendVisitorEmailAddressRequested = exports.sendVisitorEmailAddressRequested = (0, _reduxActions.createAction)(ActionTypes.SEND_VISITOR_EMAIL_ADDRESS, function (email) {
  return { email: email };
});

var sendVisitorEmailAddressFailed = exports.sendVisitorEmailAddressFailed = (0, _reduxActions.createAction)(ActionTypes.SEND_VISITOR_EMAIL_ADDRESS_FAILED, function (error) {
  return { error: error };
});

var sendVisitorEmailAddressSucceeded = exports.sendVisitorEmailAddressSucceeded = (0, _reduxActions.createAction)(ActionTypes.SEND_VISITOR_EMAIL_ADDRESS_SUCCEEDED, function (email) {
  return { email: email };
});

function sendVisitorEmailAddress(_ref) {
  var channel = _ref.channel,
      _ref$consentToCommuni = _ref.consentToCommunicate,
      consentToCommunicate = _ref$consentToCommuni === undefined ? false : _ref$consentToCommuni,
      email = _ref.email;

  return function (dispatch, getState) {
    dispatch(sendVisitorEmailAddressRequested(email));

    var successCb = function successCb() {
      dispatch(sendVisitorEmailAddressSucceeded(email));
      dispatch((0, _publishEmailCaptureResponseMessage2.default)({ channel: channel, email: email }));

      if (consentToCommunicate) {
        dispatch((0, _visitorConsentsToCommunicate.visitorConsentsToCommunicate)(consentToCommunicate));
      }

      dispatch((0, _trackInteraction.trackInteraction)('widget-interaction', {
        action: 'submit email'
      }));

      return { error: null };
    };

    var failureCb = function failureCb(error) {
      dispatch(sendVisitorEmailAddressFailed(error));

      return { error: error };
    };

    var chainablePromise = EmailCaptureClient.sendVisitorEmailAddress({
      channel: channel,
      email: email,
      sessionId: (0, _getSessionId.getSessionId)(getState())
    }).then(successCb, failureCb);

    chainablePromise.done();

    return chainablePromise;
  };
}


//////////////////
// WEBPACK FOOTER
// ./js/email-capture/actions/VisitorEmailAddressActions.js
// module id = 353
// module chunks = 2 3